import { network } from 'services/network';

export const getComponentsLibrary = () => {
    return network.post('api/bo/reporting/getComponentsLibrary').then((response) => {
        return response.data;
    });
};
